import { INITIALIZE_PROMOTED_EVENTS } from '../actions/sponsorship';

export const promotedEventsReducer = (state = [], { type, payload }) => {
    switch (type) {
        case INITIALIZE_PROMOTED_EVENTS: {
            const { promotedEvents } = payload;

            return promotedEvents;
        }

        default:
            return state;
    }
};
